import { call, select } from 'redux-saga/effects';
import { ReactionsManager } from 'features/room-reactions/utils/ReactionsManager';
import { Reaction, ReactionItem } from 'features/room-reactions/types';
import { signalingRoomReactionsReceived } from 'features/room-reactions/actions';
import { selectE2eeEnabled } from 'features/e2ee/e2eeSlice';
import { selectRoomId } from 'features/room/roomSlice';
import { E2EEManager } from 'features/e2ee/E2EEManager';
import { selectUserById } from 'features/users/usersSlice';
import { User, UserId } from 'features/users/types';
import { selectRecordingHiddenUserIds } from 'features/layout/features/config/systemSessionSelectors';

export function* onRoomReactionsReceivedSaga(
  action: ReturnType<typeof signalingRoomReactionsReceived>
) {
  const {
    initiator,
    data: { reactions },
  } = action.payload;

  const user: User = yield select(selectUserById, initiator.id);
  if (!user) {
    return;
  }

  const hiddenUserIds: UserId[] = yield select(selectRecordingHiddenUserIds);
  if (hiddenUserIds.includes(user.id)) {
    return;
  }

  const e2eeEnabled: boolean = yield select(selectE2eeEnabled);
  if (e2eeEnabled) {
    if (!user.name) {
      const roomId: string = yield select(selectRoomId);
      yield call(
        E2EEManager.enqueuePendingAction,
        signalingRoomReactionsReceived(action.payload),
        roomId
      );

      return;
    }
  }

  if (reactions && Array.isArray(reactions)) {
    const data: ReactionItem[] = reactions.map((reaction) => ({
      reaction: reaction as Reaction,
      initiator: user,
    }));

    yield call(ReactionsManager.triggerReactions, data, user.id);
  }
}
